import React from 'react';
import PropTypes from 'prop-types';

import AccessTime from '@material-ui/icons/AccessTime';
import { withStyles } from '@material-ui/core/styles';

import Theme from 'LegacyWeployDesignLanguage/Theme';
import commonStyles from './styles';

const styles = () => ({
  icon: {
    ...commonStyles().icon,
    color: Theme.colors.white,
  },
});

const AccessTimeIcon = ({
  classes,
}) => (
  <AccessTime className={classes.icon} />
);

AccessTimeIcon.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccessTimeIcon);
